
import React from 'react';
import Modal from 'react-modal';
import { setCookie } from '../../inc/cookies';

export default class AggrementsModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    return (
      <div className="modal inmodal">
        <div className="modal-dialog">
          <div className="modal-content animated fadeIn">
            <Modal
              isOpen={this.props.isOpen}
              style={{
                content: {
                  position: 'null',
                  top: 'null',
                  left: 'null',
                  right: 'null',
                  bottom: 'null',
                  border: 'none',
                  background: '#fff',
                  padding: 'null',
                  maxWidth: '50%',
                  maxHeight: '50%',
                  minWidth: '350px'
                },
                overlay: {
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(0,0,0,00.1)',
                  zIndex: 2500
                }
              }}
            >
              <div>
                <div className="modal-header d-block text-center text-darkblue">
                  <h4 className="modal-title">Satış Kuralları</h4>
                  <h5 className="font-normal">Satış Kuralları</h5>
                </div>
                <div className="modal-body text-darkblue" style={{ maxHeight: '240px', overflowY: 'auto' }}>
                  <div>
                    <h1>Satış Garanti Satış Kuralları <b className="text-danger">(08.09.2025)</b></h1>
                    <ul className="list-decimal list-inside space-y-2">
                      <li>
                        CRM’de potansiyel kaydı açılan müşteriler ilk 15 gün kaydı ilk açan
                        kişiye ait olmaktadır. Burada bakılacak nokta kaydı açan kişinin ilk
                        kayıt tarihidir. Müşteri hesap kesim tarihi, ödeme müsaitliği için
                        tarih verdiği takdirde ve bu tarih CRM kayıtlarında varsa o tarih
                        beklenip sonrasında (Ödeme gerçekleşmez ise) başkası tarafından
                        aranabilir. (Kaydı ilk açan kişi veya başka kişide olsa sürekli kayıt
                        revize edilemez. Bu gibi bir durumda ilk giriş hareketine
                        bakılacaktır ve kim satarsa ciro o kişiye aittir.)
                      </li>
                      <li>
                        CRM kayıtlarında potansiyel üye, kuralımız olan 15 gün sonrasına
                        herhangi bir zaman dilimine öteler ve temsilci örnek olarak 16 gün
                        sonraya görüşme kaydı oluşturmuş dahi olsa farklı bir arkadaşımız o
                        üyenin satışını gerçekleştirebilir. Bunun için farklı bir satış
                        temsilcisi 15 gün kuralını beklemek durumunda değildir.
                      </li>
                      <li>
                        Tele satış tarafından sahaya yapılan yönlendirmelerde saha eğer o
                        müşteriyi ziyaret etmeyip sadece telefonla iletişime geçiyorsa ve
                        sonrasında o satışı Tele satış tek başına kapatmış olduğunda sahaya
                        ortak yazılmayacaktır. (Saha sahada olmak zorunda ve fiziki olarak
                        şirket aracı ile ziyarette bulunmak ve sunum yapmak zorunda) aksi
                        halde Tele satışa tek yazılır.
                      </li>
                      <li>
                        CRM kaydı bulunmayan satış danışmanı başka birisi tarafından o
                        potansiyel üyeye satış yapıldığında herhangi bir ciro hakkı talep
                        edemez, CRM kayıtları eksiksiz girilmesi gerekmektedir.
                      </li>
                      <li>
                        Yönlendirmelerde yönlendirme yapan Tele satışta olan arkadaşım 1 ay
                        saha ile ortak yürütebilir ve saha o müşteriyi ziyaret gerçekleştirdiyse
                        satışı yönlendiren kişi satmış olsa da satış ortak yazılır. Bu
                        yönlendirmede ilk kayıt tarihi 1 ayı geçmişse başka bir Tele satışta
                        olan arkadaşımız arama yapabilir ve istediği saha ile çalışabilir ve
                        ona yönlendirme yapabilir. Saha ziyaretlerde yaptığı bölgede 15 gün
                        süre içinde bölgesine dönse bile satışı kapatabilir.
                      </li>
                      <li>
                        Paket sunumlarında paket içerik ürünlerine dair tüm dokümanlar,
                        bilgilendirmeler ve güncellemeler paylaşılmaktadır. Doğru ürün bilgisi
                        için bunların okunması ve takip edilmesi, üyelere doğru bilgi paylaşımı
                        için dokümanların ve maillerin okunması gerekmektedir.
                      </li>
                      <li>
                        Tele Satış tarafından saha tarafına atılan yönlendirmelerin mutlaka
                        ziyaret edilmesi gerekmektedir ve sonuçlar CRM kayıtlarına giriş
                        yapılmalıdır.
                      </li>
                      <li>
                        Her bir arkadaşımız şirket düzeninin korunması adına belirtilen satış
                        kurallarına uymak zorundadır.
                      </li>
                      <li>
                        Satış hangi temsilcinin üzerinde açılmış ise o temsilcinin üzerinde
                        kalır, haklı bir gerekçe olmadığı takdirde satış asla değiştirilemez.
                      </li>
                      <li>
                        Üye paket süresi bitimine kadar asla yenileme için yetkili kişiler
                        dışında aranmayacaktır. Saha ve diğer ekipler dahildir.
                      </li>
                      <li>
                        Üyeliği bitmiş yenilemelerde bölge farkı olmadan satış yapılabilir, 15
                        gün kuralı geçerlidir.
                      </li>
                      <li>
                        Hediye ekspertizler email onaylı ve müşteriye kod gönderilerek
                        verilecektir. (Her temsilci ayda 1 defa verebilir.)
                      </li>
                      <li>
                        Sahaya yönlendirme yapılan potansiyel üyenin adresi veya konum bilgisi
                        verilmediği takdirde yönlendirme sayılmaz.
                      </li>
                      <li>
                        Yenilemelerde aylık olarak yenileme listesi dağıtılmadan yenileme
                        yapılmayacaktır.
                      </li>
                      <li>
                        Sahaya gelen referanslarda satışlar referans gelen kişiye yazılır.
                      </li>
                      <li>
                        İçeriden gelen yönlendirmeler saha (Yeni Saha Satışı 2 Ay Kuralına
                        Tabidir) dahil bölge sahibine yönlendirilir.
                      </li>
                    </ul>

                    <h2 className="text-xl font-bold">Revizyon ve Manipülasyon Engeli</h2>
                    <ul className="list-decimal list-inside space-y-2">
                      <li>
                        <b>İlk Kaydı Açan Kişinin Koruma Süresi</b>
                        <ul className="list-disc list-inside ml-6">
                          <li>
                            İlk aramada müşteriyle gerçek görüşme olmamışsa yani sunum ve satış
                            adına bilgi verilmemişse (meşgul, açmadı, yüzüme kapattı vb.) 15
                            gün bloke hakkı <b>doğmaz.</b>
                          </li>
                          <li>
                            Temsilciye sadece <b>(aynı gün olmak üzere) günlük tekrar deneme hakkı</b>
                            tanınır.
                          </li>
                          <li>
                            Aynı gün boyunca temas sağlanmazsa kayıt otomatik olarak havuza
                            düşer.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <b>Revize Etme Yasağı</b>
                        <ul className="list-disc list-inside ml-6">
                          <li>CRM’de bir kayıt açıldıktan sonra <b>görüşme sonucu sonradan değiştirilemez.</b></li>
                          <li>
                            “Meşgul” girilen kayıt sonradan “Görüşüldü” olarak revize edilirse,
                            sistem bunu log’lamalı ve yöneticinin onayı olmadan geçerli
                            sayılmamalıdır.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <b>Satış Sahipliğinde “İlk Temas” Esası</b>
                        <ul className="list-disc list-inside ml-6">
                          <li>Satışı kapatan kişi kimse, hak onun olur.</li>
                          <li>
                            İlk kaydı açan ama müşteriyle temas kuramayan temsilci, satış
                            kapanmadıkça ciro hakkı talep edemez.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <b>Yönetici Onay Mekanizması</b>
                        <ul className="list-disc list-inside ml-6">
                          <li>
                            15 gün sonunda satış başka bir temsilci tarafından kapanırsa, ilk
                            kaydı açan temsilci ancak <b>kanıtlı bir görüşme</b> (örneğin CRM kaydı,
                            mail ekran görüntüsü) sunabiliyorsa hak iddia edebilir.
                          </li>
                          <li>
                            Aksi durumda satış otomatik olarak kapatan temsilciye yazılır.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <b>Sahte Bahane Engeli</b>
                        <ul className="list-disc list-inside ml-6">
                          <li>“Aradım açmadı, kapattı, meşguldü” gibi gerekçeler satış sahipliği yapmaz.</li>
                          <li>Ancak CRM’de “müşteriyle konuşma gerçekleşti” kaydı varsa hak doğar.</li>
                        </ul>
                      </li>
                    </ul>

                    <h2 className="text-xl font-bold">Hatırlatma</h2>
                    <ul className="list-disc list-inside space-y-2">
                      <li>Yıllık izin kullanım yapıldığı aylarda aylık verilen hedeflerde hedef düşümü yapılmaz.</li>
                      <li>
                        İptal ve iadelerde iade edilen tutar satışlardan sorumlu olan kişinin
                        bir sonraki ay alacak olduğu hedefine eklenir.
                      </li>
                      <li>
                        İptal ve iadede müşteriye iade edilecek tutar promosyon, olta bayrak
                        gönderimi, kullanmış olduğu ücretsiz ekspertizine, kredi girişleri veya
                        kullandırımlarına ve kullandığı kredi kart durumuna bakılarak
                        belirlenmektedir. Onay maili tarafıma atılması gerekmektedir.
                      </li>
                      <li>
                        Şehir dışı seyahatlerde konaklamada şirketin ödeyeceği tutar için onay
                        alınması gerekmektedir.
                      </li>
                      <li>Mesai dışı araç kullanımda onay alınması gerekmektedir.</li>
                      <li>
                        Yenileme görüşmeleri sonu olumsuz olduğunda mail yolu ile üyenin
                        sayfasının açık kalmaması ve ilanlarının silinmesi için satış desteğe
                        bilgi verilmesi gerekmektedir.
                      </li>
                      <li>
                        Şirket personellerimiz şirketimizi temsil ettiğinden dolayı kılık
                        kıyafetine, saç sakal tıraşı mutlaka özen göstermesi gerekmektedir.
                      </li>
                      <li>
                        Herhangi bir mazeret kullanarak mesaisinin başında olamayacak
                        arkadaşlarımız mutlaka mazeretini belirterek mazeret izin formu
                        doldurup imzalayıp muhasebe tarafımıza iletmek zorundadır.
                      </li>
                      <li>
                        SGK, 5510 sayılı Sosyal Sigortalar ve Genel Sağlık Sigortası Kanunu'nun
                        18. maddesi gereği, raporlu olunan 3 gün ve sonrası için rapor parası
                        ödemesi yapıyor. Yasal olarak işverenin ilk iki gün için ödeme yapması
                        zorunluluğu bulunmuyor.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-orange" onClick={() => { this.props.onRequestClose(); setCookie("aggrements", 1) }}>Onaylıyorum</button>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    )
  }
}